<!--  -->
<template>
  <el-badge :value="value" :hidden="value==0">
    <div class="shop-card-icon" @click="toShopCart">
      <img src="@/assets/img/shopcart-icon.png" />
    </div>
  </el-badge>
</template>

<script>
export default {
  name: "ShopCardIcon",
  props: {
    value: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    toShopCart() {
      this.$router.push(`/e-shop/shop-cart`);
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.shop-card-icon {
  img {
    width: 40px;
    height: 35px;
    cursor: pointer;
  }
}
</style>
